import api from './api'

const ENDPOINT = '/admin/treatments'

const TreatmentsService = {
  async getAll(params = {}) {
    const response = await api.get(ENDPOINT, { params })
    return response.data
  },

  async getById(id) {
    const response = await api.get(`${ENDPOINT}/${id}`)
    return response.data
  },

  async create(data) {
    const response = await api.post(ENDPOINT, data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`${ENDPOINT}/${id}`, data)
    return response.data
  },

  async delete(id) {
    const response = await api.delete(`${ENDPOINT}/${id}`)
    return response.data
  },
}

export default TreatmentsService
